import { createLucideIcon } from 'lucide-react';
export const EditIcon = createLucideIcon('edit', [
  [
    'path',
    {
      d: 'M13 6H4V19.25H18V12.5',
      key: 'ttie2v',
    },
  ],
  [
    'path',
    {
      d: 'M20 4C20.5919 4 21.5 4.34257 21.5 5C21.5 5.5 21 6 21 6L14 13L11.9688 13.5V11.5L19 4.5C19.167 4.33301 19.4081 4 20 4Z',
      key: '1fxfcg',
    },
  ],
]);
